import type { ErrorMessage } from '@/core/api/error-messages';

export const ADMIN_USER_ERRORS: Record<string, ErrorMessage> = {
  'AdminUser.InvalidCredentials': {
    title: 'Credenciales incorrectas',
    message: 'Credenciales incorrectas.',
    severity: 'error',
  },
  'AdminUser.NotAuthenticated': {
    title: 'No autenticado',
    message: 'Debes iniciar sesión para acceder a esta sección.',
    severity: 'error',
  },
  'AdminUser.Deactivated': {
    title: 'Cuenta desactivada',
    message: 'Esta cuenta ha sido desactivada.',
    severity: 'error',
  },
  'AdminUser.Forbidden': {
    title: 'Acción no permitida',
    message: 'No tienes permisos para realizar esta acción.',
    severity: 'error',
  },
  'AdminUser.AccountLocked': {
    title: 'Cuenta bloqueada',
    message: 'Tu cuenta ha sido bloqueada por seguridad. Intenta de nuevo en 30 minutos.',
    severity: 'warning',
  },
  'AdminUser.PendingActivation': {
    title: 'Cuenta pendiente de activación',
    message: 'Tu cuenta está pendiente de activación.',
    severity: 'warning',
  },
  'AdminUser.CannotSelfDeactivate': {
    title: 'Acción no permitida',
    message: 'No puedes desactivar tu propia cuenta.',
    severity: 'error',
  },
  'AdminUser.LastActiveSuperAdmin': {
    title: 'Acción no permitida',
    message: 'No se puede desactivar al último Super Admin activo del sistema.',
    severity: 'error',
  },
  'AdminUser.NotFound': {
    title: 'Usuario no encontrado',
    message: 'El usuario solicitado no existe.',
    severity: 'error',
  },
  'AdminUser.AlreadyExists': {
    title: 'Correo ya registrado',
    message: 'Ya existe un administrador con este correo electrónico.',
    severity: 'warning',
  },
  'AdminUser.AlreadyActive': {
    title: 'Usuario ya activo',
    message: 'Este usuario ya se encuentra activo.',
    severity: 'warning',
  },
  'AdminUser.InvalidPasswordResetToken': {
    title: 'Enlace inválido',
    message: 'El enlace de recuperación no es válido.',
    severity: 'error',
  },
  'AdminUser.PasswordResetTokenExpired': {
    title: 'Enlace expirado',
    message: 'El enlace de recuperación ha expirado. Solicita uno nuevo.',
    severity: 'warning',
  },
  'AdminUser.PasswordResetTokenAlreadyUsed': {
    title: 'Enlace ya utilizado',
    message: 'Este enlace ya fue utilizado.',
    severity: 'warning',
  },
  'AdminUser.InvalidCurrentPassword': {
    title: 'Contraseña incorrecta',
    message: 'La contraseña actual es incorrecta.',
    severity: 'error',
  },
  'AdminUser.InvalidExternalId': {
    title: 'ID externo inválido',
    message: 'El ID externo proporcionado no es válido.',
    severity: 'error',
  },
  'AdminUser.WeakPassword': {
    title: 'Contraseña débil',
    message: 'La contraseña no cumple con los requisitos mínimos de seguridad.',
    severity: 'error',
  },
  'AdminUser.TooManyRequests': {
    title: 'Demasiadas solicitudes',
    message: 'Has realizado demasiadas solicitudes. Intenta de nuevo más tarde.',
    severity: 'warning',
  },
  'AdminUser.SupabaseError': {
    title: 'Error del servidor',
    message: 'Ocurrió un error en el servidor. Intenta de nuevo más tarde.',
    severity: 'error',
  },
  'AdminUser.PasswordResetError': {
    title: 'Error al restablecer contraseña',
    message: 'Ocurrió un error durante el restablecimiento de contraseña.',
    severity: 'error',
  },
  'AdminUser.InvalidPasswordSetupToken': {
    title: 'Enlace inválido',
    message: 'El enlace de configuración de contraseña es inválido. Por favor, solicita uno nuevo.',
    severity: 'error',
  },
  'AdminUser.PasswordSetupTokenExpired': {
    title: 'Enlace expirado',
    message: 'El enlace de configuración de contraseña ha expirado. Por favor, solicita uno nuevo.',
    severity: 'warning',
  },
  'AdminUser.PasswordSetupTokenAlreadyUsed': {
    title: 'Enlace ya utilizado',
    message:
      'Este enlace de configuración de contraseña ya ha sido utilizado. Por favor, solicita uno nuevo.',
    severity: 'warning',
  },
  'AdminUser.PasswordSetupError': {
    title: 'Error al configurar contraseña',
    message: 'Ocurrió un error durante la configuración de contraseña.',
    severity: 'error',
  },
  'AdminUser.PasswordSetupRateLimit': {
    title: 'Demasiadas solicitudes',
    message:
      'Has realizado demasiadas solicitudes de configuración de contraseña. Intenta de nuevo más tarde.',
    severity: 'warning',
  },
  'AdminUser.CannotSelfChangeRole': {
    title: 'Acción no permitida',
    message: 'No puedes cambiar tu propio rol.',
    severity: 'error',
  },
  'AdminUser.LastActiveSuperAdminRoleChange': {
    title: 'Acción no permitida',
    message: 'No se puede cambiar el rol del último Super Admin activo del sistema.',
    severity: 'error',
  },
  'AdminUser.CannotActivatePendingUser': {
    title: 'Usuario pendiente de activación',
    message:
      'Este usuario aún no configuró su contraseña. Usa "Reenviar invitación" en lugar de activar.',
    severity: 'warning',
  },
  'AdminUser.NotPendingActivation': {
    title: 'Acción no disponible',
    message: 'Solo puedes reenviar la invitación a usuarios pendientes de activación.',
    severity: 'warning',
  },
};
